import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './styles.less';
import { isTablet, isMobile } from 'react-device-detect';
import classNames from 'classnames';

export function MobileOverlay() {
  const { t } = useTranslation();
  return (
    <div
      className={classNames(
        styles.mobileOverlay,
        isTablet ? styles.tablet : '',
      )}
    >
      <div className={styles.overlayContent}>
        <div
          className={styles.mobileMessage}
          style={{ width: '90%', margin: '0 auto' }}
        >
          <div className={styles.alertYellow}>
            <strong>
              {t(
                'BookWright Online is not available on mobile devices, please continue on a desktop.',
              )}
            </strong>
            <br />
            {t(
              'We currently do not support BookWright Online on mobile devices. You can learn more about our products and creation tools at Blurb.com, and create your project next time you are on a desktop device.',
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
